<template>
  <div class="properties-panel-column">
    <div class="panel-content" v-if="activePartId && part" :key="activePartId">
      <SectionProperties
        v-if="part.part_type === 's'"
        :partId="activePartId"
        @save="onSave"
        @cancel="onCancel"
      />
      <QuestionProperties
        v-else-if="part.part_type === 'q'"
        :partId="activePartId"
        @save="onSave"
        @cancel="onCancel"
      />
      <ParagraphProperties
        v-else-if="part.part_type === 'p'"
        :partId="activePartId"
        @save="onSave"
        @cancel="onCancel"
      />
      <PageBreakProperties
        v-else-if="part.part_type === 'b'"
        :partId="activePartId"
        @save="onSave"
        @cancel="onCancel"
      />
      <EsignatureProperties
        v-else-if="part.part_type === 'e'"
        :partId="activePartId"
        @save="onSave"
        @cancel="onCancel"
      />
      <div v-else>
        Unknown part type.
      </div>
    </div>
    
    <div class="empty-state" v-else>
      <v-icon size="48" color="grey lighten-1">mdi-cursor-default-click</v-icon>
      <p>Click on a component in the designer to view and edit its properties here.</p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import SectionProperties from '../properties/Section'
import QuestionProperties from '../properties/Question'
import ParagraphProperties from '../properties/Paragraph'
import PageBreakProperties from '../properties/PageBreak'
import EsignatureProperties from '../properties/Esignature'

export default {
  name: 'PropertiesPanel',
  components: {
    SectionProperties,
    QuestionProperties,
    ParagraphProperties,
    PageBreakProperties,
    EsignatureProperties
  },
  computed: {
    ...mapState('formtemplate', ['activePartId']),
    ...mapGetters('formtemplate', [
      'partById'
    ]),
    part() {
      if (!this.activePartId) return null
      return this.partById(this.activePartId)
    }
  },
  methods: {
    onSave() {
      // The properties component handles the API save. We just know it's done.
      // We might want to keep it selected, or we could emit an event if needed.
    },
    onCancel() {
      // User clicked cancel in properties
      this.$store.commit('formtemplate/setActivePartId', null)
    }
  }
}
</script>

<style scoped>
.properties-panel-column {
  background-color: #fafafa;
  border-left: 1px solid #e0e0e0;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.panel-header {
  padding: 16px;
  border-bottom: 1px solid #e0e0e0;
  background-color: white;
}

.panel-header h3 {
  margin: 0 0 4px 0;
  font-size: 16px;
  font-weight: 500;
}

.panel-header p {
  margin: 0;
  font-size: 12px;
  color: #666;
}

.panel-content {
  flex-grow: 1;
  overflow-y: auto;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 32px;
  text-align: center;
  color: #999;
  border: unset !important;
}

.empty-state p {
  margin-top: 16px;
  font-size: 14px;
}
</style>
